"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONCUR_LIST_NAME_SEPARATOR = exports.CONCUR_LIST_CODE_SEPARATOR = void 0;
var util_1 = require("../util");
exports.CONCUR_LIST_CODE_SEPARATOR = util_1.DEFAULT_CODE_SEPARATOR;
exports.CONCUR_LIST_NAME_SEPARATOR = ">";
